<template>
  <div class="epg-container container-fluid g-0">
    <div class="row g-0 mb-2">
      <div class="col-12 epg-head ">
        {{ t(activeChannel, 'title') }}
      </div>
    </div>
    <div class="row g-0">
      <div class="container-fluid epg-list" :style="{'max-height':(maxHeight - 40) + 'px' }">
        <div class="row epg-item g-0 my-2 position-relative" v-for="epgItem in epgList"
             :class="{'active-item':isActive(epgItem)}">
          <div class="col item-title p-3 pb-1" :title="t(epgItem, 'title')">
            {{ t(epgItem, 'title') }}
          </div>
          <div class="col-12 item-time p-3 pt-1">
            {{ epgItem.start }} - {{ epgItem.end }}
          </div>
          <div class="on-air" v-if="isActive(epgItem)">
            <span class="dot"></span>
            {{ tText('on_air') }}
          </div>
        </div>
        <div v-if="!epgList.length">
          {{ tText('epg_not_found') }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import epgSrv from "../../service/epg";
  import {contentTranslate} from "../../mixin/translate.js";

  export default {
    name: "EpgList",
    mixins: [contentTranslate],
    props: {
      maxHeight: {
        type: Number,
        default: null
      },
      showOnlyActive: {
        type: Boolean,
        default: false
      },
      activeChannel: {
        type: Object
      }
    },
    computed: {

      epgList() {
        if (this.showOnlyActive) {
          return this.activeChannel.epgList.length ? [epgSrv.getActiveEpg(this.activeChannel.epgList)] : []
        } else {
          return this.activeChannel.epgList.length ? epgSrv.filter(this.activeChannel.epgList) : []
        }
        // return this.activeChannel.epg.length ? (this.showOnlyActive ? [epgSrv.getActiveEpg(this.activeChannel.epg)] : epgSrv.filter(this.activeChannel.epg)) : [];
      },
    },
    mounted() {
    },
    methods: {


      isActive(epgItem) {
        return epgSrv.isActive(epgItem);
      }
    }
  }
</script>

<style lang="scss">
  .epg-container {
    color: #343434;

    .epg-head {
      font-weight: 500;
      font-size: 20px;
      line-height: 23px;
      letter-spacing: 0.03em;
      text-transform: uppercase;
    }

    .epg-list {

      overflow-y: auto;

      .epg-item {
        background: #ECF0F7;
        border-radius: 5px;
        width: 100%;

        &.active-item {
          .item-title {
            max-width: calc(100% - 120px);
          }
        }

        .item-title {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          //-webkit-line-clamp: 2;
          //overflow: hidden;
          //-webkit-box-orient: vertical;
          //white-space: nowrap;
          max-height: calc(37px + 1rem);
          font-weight: 500;
          font-size: 15px;
          line-height: 18px;
          //overflow: hidden;
          //text-overflow: ellipsis;
          //white-space: nowrap;
        }

        .item-time {
          font-weight: normal;
          font-size: 15px;
          line-height: 18px;
        }
      }

      .on-air {

        font-weight: 500;
        font-size: 14px;
        position: absolute;
        left: calc(100% - 120px);
        top: 12px;
        background-color: #CEDBED;
        border-radius: 5px;
        color: #343434;
        width: 100px;
        padding: 12px 0;
        text-align: center;

        .dot {
          margin-bottom: 1px;
          width: 8px;
          display: inline-block;
          height: 8px;
          border-radius: 8px;
          background-color: #F14040;
        }
      }
    }

  }
</style>
